import { reformatDate } from '@/utils/date.js'
import type { TCommon } from '~/types/app.type'

export function formatText(value?: string | number) {
  const isNumber = typeof value === 'number'
  const isDate = /\d{4}-\d{1,2}-\d{1,2}/.exec(String(value))

  if (!isNumber && !isDate) return value

  // Format as number.
  if (isNumber) return value.toLocaleString('en')

  // Format as date.
  return reformatDate(value)
}

export function setAxisTitles(
  chartOptions: TCommon,
  options: TCommon,
  color: string,
  font: TCommon,
) {
  if (chartOptions.yAxes?.scaleLabel)
    options.scales.y.title = {
      display: Boolean(chartOptions.yAxes?.scaleLabel?.labelString),
      text: chartOptions.yAxes.scaleLabel.labelString,
      color,
      font,
    }

  if (chartOptions.xAxes?.scaleLabel)
    options.scales.x.title = {
      display: Boolean(chartOptions.xAxes?.scaleLabel?.labelString),
      text: chartOptions.xAxes.scaleLabel.labelString,
      color,
      font,
    }
}
